var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env.js';
import { Entity } from '@decahedron/entity';
var StarredRecruitmentsRepository = /** @class */ (function (_super) {
    __extends(StarredRecruitmentsRepository, _super);
    function StarredRecruitmentsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT;
        _this.entity = Entity;
        _this.url = 'v5/starred-recruitments';
        return _this;
    }
    StarredRecruitmentsRepository.prototype.addFavourite = function (jobId) {
        return this.post(this.url, { recruitment_id: jobId }).then();
    };
    StarredRecruitmentsRepository.prototype.deleteFavourite = function (jobId) {
        return this.axios.delete("" + this.baseUrl + this.url + "?recruitment_id=" + jobId);
    };
    return StarredRecruitmentsRepository;
}(AbstractRepository));
export { StarredRecruitmentsRepository };
